import { render, staticRenderFns } from "./AsientosVuelta.vue?vue&type=template&id=f027250a&scoped=true&"
import script from "./AsientosVuelta.vue?vue&type=script&lang=js&"
export * from "./AsientosVuelta.vue?vue&type=script&lang=js&"
import style0 from "./AsientosVuelta.vue?vue&type=style&index=0&id=f027250a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f027250a",
  null
  
)

export default component.exports